module.exports = __webpack_public_path__ + "img/clue icon.7c6a1c4a.svg";